import { isAccountReferenceEqual } from './isAccountReferenceEqual';
/**
 * Returns true if the given instance reference matches the given instance.
 */
export function isInstanceMatch(instance, instanceRef) {
    var _a;
    if (!instance || !instanceRef) {
        // when neither are truthy then they match if they're both falsy
        return !instance && !instanceRef;
    }
    if ((instanceRef === null || instanceRef === void 0 ? void 0 : instanceRef.authenticationSubject) &&
        instanceRef.authenticationSubject !== instance.authenticationSubject) {
        return false;
    }
    if ((instanceRef === null || instanceRef === void 0 ? void 0 : instanceRef.accountReference) &&
        !isAccountReferenceEqual(instanceRef.accountReference, instance.accountReference)) {
        return false;
    }
    if ((instanceRef === null || instanceRef === void 0 ? void 0 : instanceRef.authenticationReason) &&
        !((_a = instance.authenticationStrategies[instanceRef.authenticationReason]) === null || _a === void 0 ? void 0 : _a.length)) {
        return false;
    }
    return true;
}
